import type { Project } from '../components/minimal';

export const securityResearch: Project[] = [
  {
    title: 'Linux Kernel io_uring OOB Read',
    description:
      'Out-of-bounds read in io_uring SQE_MIXED handling. sq_array physical index validation was missing, enabling a deterministic unprivileged 64-byte OOB read. Fix merged into mainline by Jens Axboe, backported to 6.19-stable.',
    status: 'merged',
    statusLabel: 'FIX MERGED',
    tags: ['C', 'kernel', 'io_uring', 'memory safety'],
    links: [
      {
        label: 'Writeup & PoC',
        url: 'https://gist.github.com/Atomics-hub/88b2c497166c838cc63633c5ce32c259',
      },
    ],
  },
  {
    title: 'V8 Maglev JIT Uninitialized Memory',
    description:
      "Uninitialized saved_mode_ in SaveCallSpeculationScope in V8's Maglev JIT compiler. Submitted to Chromium, peaked P1/S1 severity. Fixed by the V8 team.",
    status: 'fixed',
    statusLabel: 'FIXED',
    tags: ['C++', 'V8', 'JIT', 'Chromium'],
    links: [
      { label: 'Writeup', url: 'https://gist.github.com/Atomics-hub/baf37d7f7402a5011bbed61208872339' },
    ],
  },
  {
    title: 'DoD Vulnerability Disclosure',
    description:
      'Two Keycloak ROPC brute-force vulnerabilities in Department of Defense systems. Submitted through the DoD VDP on HackerOne.',
    status: 'submitted',
    statusLabel: 'SUBMITTED',
    tags: ['Keycloak', 'web security', 'DoD'],
    links: [],
  },
];

export const openSource: Project[] = [
  {
    title: 'Flowdown',
    description:
      'O(1) streaming markdown renderer for AI chat UIs. 2,146x faster than marked for streaming workloads. ~4KB gzipped, zero dependencies.',
    status: 'published',
    statusLabel: 'NPM',
    tags: ['TypeScript', 'streaming', 'markdown'],
    links: [
      { label: 'GitHub', url: 'https://github.com/Atomics-hub/flowdown' },
      { label: 'npm', url: 'https://www.npmjs.com/package/@a5omic/flowdown' },
    ],
  },
  {
    title: 'Logpack',
    description:
      'Columnar compression for JSON logs. 30-47x compression ratios, 30-53% smaller than zstd-19 at 20x the speed.',
    status: 'published',
    statusLabel: 'CRATE',
    tags: ['Rust', 'compression', 'logging'],
    links: [{ label: 'GitHub', url: 'https://github.com/Atomics-hub/logpack' }],
  },
  {
    title: 'Veil API',
    description:
      'PII redaction middleware for LLM providers. Strips sensitive data before upstream, restores on response. 79 entity types, 41 providers, 18 countries.',
    status: 'live',
    statusLabel: 'LIVE',
    tags: ['Python', 'FastAPI', 'privacy'],
    links: [
      { label: 'GitHub', url: 'https://github.com/Atomics-hub/veil' },
      { label: 'veil-api.com', url: 'https://veil-api.com' },
    ],
  },
];

export const apps: Project[] = [
  {
    title: 'Overboard',
    description:
      'Native imageboard client for iOS, iPadOS, watchOS, and visionOS. On-device ML content moderation via CoreML, iCloud sync, full-screen media browsing. ~1,000 users.',
    status: 'live',
    statusLabel: 'APP STORE',
    tags: ['Swift', 'SwiftUI', 'CoreML', 'visionOS'],
    links: [{ label: 'Website', url: 'https://overboard-app.web.app/' }],
  },
];

export const research: Project[] = [
  {
    title:
      'What Must Be Preserved? Mapping Theories of Consciousness to Engineering Requirements for Mind Preservation',
    description:
      'Evaluates 8 major consciousness theories against engineering requirements for mind preservation. Theories split 4-3-1 on substrate independence. Published on Zenodo.',
    status: 'published',
    statusLabel: 'PUBLISHED',
    tags: ['consciousness', 'neuroscience', 'philosophy of mind'],
    links: [
      { label: 'Paper', url: 'https://doi.org/10.5281/zenodo.19374628' },
      { label: 'GitHub', url: 'https://github.com/Atomics-hub/consciousness-research' },
    ],
  },
];

export const leadership: Project[] = [
  {
    title: 'Founder & CEO — A5omic LLC',
    description:
      'Founded and run a software and music company. Manage 2 developers, shipped 20+ products across web, iOS, and open source. 180K+ monthly Spotify listeners.',
    status: 'live',
    statusLabel: 'ACTIVE',
    tags: ['management', 'product', 'hiring', 'full-stack'],
    links: [{ label: 'a5omic.com', url: 'https://a5omic.com' }],
  },
  {
    title: 'Founding Engineer — Integral',
    description:
      'First engineer at a seed-stage startup. Managed design contractor, defined engineering processes and CI/CD pipelines, shipped iOS product to 5K+ users in 5 months. #1 on Product Hunt for a day.',
    status: 'published',
    statusLabel: 'SHIPPED',
    tags: ['iOS', 'Swift', 'eng process', 'startup'],
    links: [],
  },
  {
    title: 'Software Engineer — Intel',
    description:
      'Designed distributed Spark pipelines processing TB+ of hardware telemetry daily. Built internal dashboards and API endpoints (React, TypeScript, Flask, PostgreSQL) used by 200+ engineers. Drove automation initiative earning Department Impact Award.',
    status: 'live',
    statusLabel: 'ACTIVE',
    tags: ['data pipelines', 'Spark', 'automation', 'full-stack'],
    links: [],
  },
];

export const musicStats = {
  monthlyListeners: '180k+',
  tracks: '96',
  monthlyViews: '420k',
};
